var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.design
        ? _c(
            "div",
            [
              _c(
                "draggable",
                {
                  staticClass: "l-drag-from",
                  attrs: { list: _vm.dataColumns, group: "componentsGroup" },
                },
                _vm._l(_vm.dataColumns, function (cp, index) {
                  return _c("draggable-item", {
                    key: index,
                    attrs: {
                      "current-item": cp,
                      "drawing-list": _vm.dataColumns,
                      index: index,
                      "in-table": true,
                      selectItem: _vm.$attrs.selectItem,
                    },
                    on: { activeItem: _vm.activeItem, deleteItem: _vm.delItem },
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    color: "#c0bebe",
                    "text-align": "center",
                    width: "90%",
                    padding: "5px",
                  },
                },
                [_vm._v("\n            ☝ 拖拽控件到表格内部\n        ")]
              ),
            ],
            1
          )
        : _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                size: "medium",
                "header-cell-style": {
                  background: "#f5f7fa",
                  padding: "3px 0",
                },
                border: true,
                data: _vm.dataList,
              },
            },
            [
              _c("el-table-column", {
                attrs: { fixed: "", type: "index", label: "序号", width: "50" },
              }),
              _vm._v(" "),
              _vm._l(_vm._columns, function (column, index) {
                return _c("el-table-column", {
                  key: index,
                  attrs: { label: column.__config__.label },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (ref) {
                          var $index = ref.$index
                          return [
                            _c("render", {
                              attrs: {
                                info: _vm.dataList[$index],
                                conf: column,
                                option: _vm.option,
                              },
                              on: {
                                input: function (value) {
                                  return _vm.setValue(
                                    value,
                                    undefined,
                                    column,
                                    $index
                                  )
                                },
                              },
                            }),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                })
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { fixed: "right", "min-width": "90", label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              disabled: _vm.readonly,
                              type: "text",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.delRow(scope.$index, scope.row)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                    删除\n                "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            2
          ),
      _vm._v(" "),
      _c(
        "el-button",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.design,
              expression: "!design",
            },
          ],
          attrs: { size: "small", icon: "el-icon-plus" },
          on: { click: _vm.addRow },
        },
        [_vm._v("添加数据")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }